<template>
    <div class="corner absolute left-0 top-0 h-[225px] w-[225px] sm:h-[300px] sm:w-[300px] z-10">
        <img src="/assets/images/svg/blue corner.svg" alt="" />
        <img src="/assets/images/svg/pointed triangle.svg" alt="" />
        <img src="/assets/images/svg/blue edge.svg" alt="" />
      </div>  
</template>